import assertEventType from 'common/bento/lib/assertEventType';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  ShouldShowResearchExperiment = 'shouldShowResearchExperiment',
}

const guards: MachineGuards<Model, Guard> = {
  shouldShowResearchExperiment: (context, event) => {
    assertEventType(event, 'done.invoke.evaluateResearchExperimentEligibility');

    return event.data;
  },
};

export default guards;
